import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRODUCT_IMAGE } from '../data/content';
const includes = ['Speech Therapy Clinical Toolkit™ Complete System', 'Complete Practice Toolkit™ — 40 clinical tools', '5 premium bonuses', 'Pediatric + adult resources', 'Instant digital access'];
export function Offer() {
  return <section id="offer" className="bg-navy-deep py-12 sm:py-16" aria-labelledby="offer-title" data-id="element-101" data-mp="tyv1j080ltsg">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-8" data-id="element-102" data-mp="ozs0rrz2i9qa">
        <h2 id="offer-title" className="font-display text-[28px] font-semibold uppercase leading-tight tracking-tightish text-ivory-light sm:text-4xl" data-id="element-103" data-mp="p1l530m7khv4">
          Speech Therapy Clinical Toolkit™
        </h2>
        <p className="mt-2 text-[12.5px] font-semibold uppercase tracking-[0.12em] text-sage sm:text-sm" data-id="element-104" data-mp="2fbxvz1p7s79f">
          The complete professional speech therapy system
        </p>

        <img src={PRODUCT_IMAGE} alt="Everything included in the Speech Therapy Clinical Toolkit system" className="mx-auto mt-5 w-full max-w-[420px] sm:mt-7" loading="lazy" data-id="element-105" data-mp="2affuqbt3er1u" />

        <ul className="mx-auto mt-6 grid max-w-sm gap-2 text-left sm:mt-8 sm:max-w-md" data-id="element-106" data-mp="ziobkvzgzo1u">
          {includes.map(item => <li key={item} className="flex items-start gap-2.5 text-[14px] leading-snug text-ivory/85 sm:text-base" data-id="element-107" data-mp="13iys32kw1wuy">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-108" data-mp="bstz4fj2c1i4" />
              {item}
            </li>)}
        </ul>

        <p className="mt-8 text-[12px] font-semibold uppercase tracking-[0.2em] text-gold-light sm:text-sm" data-id="element-109" data-mp="fsunoszvlt2w">
          Today
        </p>
        <p className="font-display text-[92px] font-semibold leading-[0.85] text-ivory-light sm:text-[140px]" data-id="element-110" data-mp="kmysp6pkzr1c">
          $27
        </p>
        <p className="mt-3 text-[11.5px] font-semibold uppercase tracking-[0.16em] text-ivory/55 sm:text-xs" data-id="element-111" data-mp="3o9fo3lefzdue">
          USD — one-time payment
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-112" data-mp="vde4yw3jnm1f">
          <CtaButton href="https://speechtherapyclinicaltoolkit.impultienda.ar/checkout" variant="gold" tone="dark" microcopy="Instant digital access • 7-day guarantee" data-id="element-113" data-mp="qfmfs9uaae0x">
            Get instant access
          </CtaButton>
        </div>
      </div>
    </section>;
}